import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { SilentError } from './error';
import { ExceptionService } from './exception.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  private exceptionService: ExceptionService;
  private zone: NgZone;

  constructor(private injector: Injector) {
    this.exceptionService = this.injector.get(ExceptionService);
    this.zone = this.injector.get(NgZone);
  }

  handleError(error: any) {
    console.error('An error occured', error);

    // we should not show anything for silent error
    if (error instanceof SilentError) {
      return;
    }

    // we should use zone.run to show error dialog properly
    this.zone.run(() => {
      this.exceptionService.handleSync(error);
    });
  }
}
